import React, { useState, useEffect, useContext } from 'react'
import MyNavBar2 from '../myComponents/MyHeader/MyNavBar2'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import Cube from '../Icons/Cube'
import GreaterThan from '../Icons/GreaterThan'
import { Link } from 'react-router-dom'
import intl from 'react-intl-universal'
import { LanguageContext } from '../../contexts/LanguageContext'
import MyModal from '../myComponents/MyModal/MyModal'
import {
  OutSideWrapper,
  HeaderWrapper,
  OrderWrapper,
  ListItem
} from './HistoricalOrdersStyle.js'
import {
  getOrderData
} from './HistoryDetailFunction'

export default function HistoricalOrders (props) {
  const Language = useContext(LanguageContext)
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [orderListdata, setOrderListData] = useState([]) // 请求到的订单列表数据
  const [showInfo, setShowInfo] = useState(false) // 是否显示提示，没有查到任何订单

  // 如果从index页面直接进来，App.js可能拿不到图片地址，这里重新获取一次
  useEffect(() => {
    getOrderData(Language, setShowModal, setModalInfo, setOrderListData, setShowInfo)
  }, [])
  // console.log(orderListdata.length)
  return (
    <OutSideWrapper className={'h100 rel ffyy' + (showInfo ? ' bgf' : '')}>
      <HeaderWrapper className='h14 rel t0 zx10'>
        <MyHeaderBg />
        <MyNavBar2 history={props.history}>{intl.get('Historical orders')}</MyNavBar2>
        {/* {<h4 className='h7 mt10 ml20 gf fs21 fw1' style={{ display: showInfo ? 'block' : 'none' }}>{intl.get('You have not ordered any meals yet.')}</h4>} */}
      </HeaderWrapper>
      {
        showInfo ? <div>
          <div className='fixed trbl0 bghistoryOrderBg' />
          <div className='abs h21r w100' style={{ bottom: '37%' }}>
            <div className='tc w100 g7c fs16 lt1' style={{ height: '1.5rem' }}>{intl.get('No order information was received from you')}</div>
          </div>
        </div>
          : <OrderWrapper className={'h86 w100 rel zx20'}>                                        { /* 订单的大盒子 */ }
            {
              orderListdata.length > 0 && orderListdata.map(item => {
                // console.log(item)
                return (
                  <Link key={item.id} to={`/historicalOrders/orderMsg/${item.id}`}>
                    <ListItem className='h26 bgf rds10 mb8'>        {/* 订单细分条目 */}
                      {/* 条目上面部分 */}
                      <ul className='h22 flex-top fs14'>
                        <li className='w17'>
                          <div className='mt-3 pl13'>
                            <Cube height={24} width={24} />
                          </div>
                        </li>
                        <li className='w45 b g9 pt2'>
                          {item.patPositionName}
                        </li>
                        <li className='w30 tr pt2'>
                          <span style={item.orderStatus === 2 || item.orderStatus === 3 ? { color: '#777' } : { color: '#2d65af' }}>
                            {item.orderStatus === null && intl.get('Unpaid')}
                            {item.orderStatus === 0 && intl.get('Unpaid')}
                            {item.orderStatus === 1 && intl.get('Booked')}
                            {item.orderStatus === 2 && intl.get('Finished')}
                            {item.orderStatus === 3 && intl.get('Cancelled')}
                          </span>
                        </li>
                        <li className='w8 tr'>
                          <div className='mt-1'>
                            <GreaterThan height={22} width={22} color={item.orderStatus === 2 || item.orderStatus === 3 ? '#ccc' : '#2f65af'} />
                          </div>
                        </li>
                      </ul>
                      {/* 条目中间分割线 */}
                      <div className='w92 bt mt5 mb5 auto gf5' />
                      {/* 条目中间部分，食物详情 */}
                      <ul className='h55 flex pl15'>
                        <li className='w100 pl10 lh1-6 g6 mt-4 fs13'>
                          <div className='mb3 no-wrap'>{intl.get('Order time:')}{item.creation_date}</div>
                          <div className='no-wrap'>{item.foodNames}</div>
                        </li>
                      </ul>
                      {/* 条目下面价格部分 */}
                      <ul className='h23 tr g8'>
                        <li className='tr pr7 fs13-8'>
                          <div className='pl3 dib pr18 mt-3'>
                            <b>{intl.get('Cash payment:')}&yen;{item.weChartPayPrice}</b>
                          </div>
                          <div className='pl3 dib pr3 mt-3'>
                            <b>{intl.get('Total price:')}&yen;{item.totalPrice}</b>
                          </div>
                        </li>
                      </ul>
                    </ListItem>
                  </Link>
                )
              })
            }
          </OrderWrapper>
      }
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => setShowModal(false)}
      />
    </OutSideWrapper>
  )
}
